import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "8",
      cy: "8",
      r: "7.5",
      fill: "#FCD252",
      stroke: "#FCD252"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.74332 9.40027H7.28342L7.05348 4H8.97326L8.74332 9.40027ZM7 11.0828C7 10.815 7.09447 10.5961 7.28342 10.4261C7.47594 10.2524 7.71479 10.1655 8 10.1655C8.28521 10.1655 8.52228 10.2524 8.71123 10.4261C8.90374 10.5961 9 10.815 9 11.0828C9 11.3505 8.90374 11.5712 8.71123 11.7449C8.52228 11.915 8.28521 12 8 12C7.71479 12 7.47594 11.915 7.28342 11.7449C7.09447 11.5712 7 11.3505 7 11.0828Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }